<template>
	<TotpSetupModal v-model:show="isModalVisible" @success="handleSuccess" />
</template>

<script setup lang="ts">
import TotpSetupModal from "@/components/profile/Security/TotpSetupModal.vue"
import { useTotpSetupModal } from "@/composables/auth/useTotpSetupModal"

const { isModalVisible, handleSuccess } = useTotpSetupModal()
</script>
